// src/pages/misc/public/FaqPage.tsx
// [HANDOFF] FAQ (/preguntas): a plain list of question / answer pairs shown as open-and-close rows (native <details>). To add a question, add a
//   pair to FAQ below. No state, no backend.
// [URL-RENAME] /preguntas -> /faq. [I18N] Texts are typed Spanish.
// [VERIFY] The pricing answer ("¿Cuánto cuesta?") says you see the price after building your structure and that paying in advance has a
//   discount. That matches the onboarding checkout (annual price), but the "welcome discount" is not implemented anywhere, see SignupPage.tsx.
import PublicShell from './PublicShell';

const FAQ = [
  ['¿Es un bot que contesta por mí?', 'No tiene que serlo. En lo mínimo, tú contestas todo y Ventaje solo documenta.'],
  ['Ya tengo un CRM.', 'En un CRM tradicional tú llenas todo. En Ventaje se llena solo y la IA conoce tus proyectos.'],
  ['¿Tengo que dejar WhatsApp?', 'No. Ventaje se conecta directo a tu WhatsApp.'],
  ['¿Qué pasa con mi información?', 'Es de tu empresa. Si un asesor se va, se queda contigo.'],
  ['¿Cuánto tarda configurarlo?', 'Unos 5 minutos según el tamaño de tu cuenta. Se hace una vez y te ayudamos.'],
  ['¿Cuánto cuesta?', 'Depende del tamaño de tu equipo. Al terminar de armar tu estructura ves el precio, y pagando por adelantado hay descuento.'],
  ['¿La IA habla en las llamadas?', 'Sí, con tu voz, si tú lo prendes. Tú decides hasta dónde llega: secretaria, asistente o más.'],
  ['¿Sirve si vendo para varias desarrolladoras?', 'Sí. Puedes tener una cuenta por empresa, o una organización que las administre todas.'],
];

const FaqPage = () => (
  <PublicShell
    pageTitle="Preguntas frecuentes"
    kicker="Preguntas frecuentes"
    title={<>Lo que <b>más nos preguntan.</b></>}
    lead="Respuestas cortas. Si la tuya no está, escríbenos desde Contacto."
  >
    <div className="pub-faq">
      {FAQ.map(([q, a]) => (
        <details key={q}>
          <summary>{q}</summary>
          <p>{a}</p>
        </details>
      ))}
    </div>
  </PublicShell>
);

export default FaqPage;
